import { assoc } from 'ramda'

export const applySavedUserSignatureToReply = (savedSignature, userName) => reply => {
  const hasSignature = savedSignature && (savedSignature.documentId || savedSignature.src)
  if (!hasSignature) return reply
  const q = reply.question
  if (q?.type?.name !== 'sign' || !q?.data?.useSavedUserSignature) return reply
  const hasValue = reply.value?.documentId || reply.value?.src
  if (hasValue) return reply
  const name = savedSignature.name || userName
  return assoc('value', { ...savedSignature, name: name || '' }, reply)
}

export const signatureReplyTransformer = executionUserContext => {
  const { savedSignature, userName } = executionUserContext || {}
  return applySavedUserSignatureToReply(savedSignature, userName)
}

/** Aplica assinatura a todos os replies no state (categories[].data). Usado no ExecutionFormHandler para não alterar formatRepliesFormData. */
export const applySignatureToState = (state, executionUserContext) => {
  if (!state?.categories) return state
  const applySignature = signatureReplyTransformer(executionUserContext)
  return {
    ...state,
    categories: state.categories.map(cat => ({
      ...cat,
      data: (cat.data || []).map(applySignature)
    }))
  }
}
